import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSidebar } from "@/components/ui/sidebar";
import { pathnameForcesSidebarCollapsed } from "@/config/sidebar-layout";

/**
 * Collapses the main sidebar on routes that carry their own secondary sidebar
 * (e.g. /candidates). Restores the previous expanded/collapsed state when leaving.
 */
export function SidebarCollapseForRoute() {
  const { pathname } = useLocation();
  const { open, setOpen } = useSidebar();
  const wasOnForcedRouteRef = useRef(false);
  const openBeforeForcedRef = useRef<boolean | null>(null);
  const openRef = useRef(open);

  useEffect(() => {
    openRef.current = open;
  }, [open]);

  useEffect(() => {
    const force = pathnameForcesSidebarCollapsed(pathname);

    if (force) {
      if (!wasOnForcedRouteRef.current) {
        openBeforeForcedRef.current = openRef.current;
        wasOnForcedRouteRef.current = true;
      }
      setOpen(false);
      return;
    }

    if (wasOnForcedRouteRef.current) {
      wasOnForcedRouteRef.current = false;
      const previous = openBeforeForcedRef.current;
      openBeforeForcedRef.current = null;
      if (previous !== null) {
        setOpen(previous);
      }
    }
  }, [pathname, setOpen]);

  return null;
}
